import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { SideMenuItem } from "./side-menu-item.model";

@Component({
  selector: "app-side-menu",
  templateUrl: "./side-menu.component.html",
  styleUrls: ["./side-menu.component.css"]
})
export class SideMenuComponent implements OnInit {
  @Input() width = "300px";
  @Input() collapsedWidth = "56px";
  @Input() menuItemIndex = 0;
  @Input() menuItems: SideMenuItem[];
  @Input() isCollapsed = false;

  @Output() menuWidthChanged = new EventEmitter<string>();
  @Output() selectedDynamicLayoutChanged = new EventEmitter<string>();
  @Output() menuItemSelectionChanged = new EventEmitter<number>();

  menuWidth: string;
  private menuItemIsVisited: boolean[] = [];

  ngOnInit() {
    this.menuWidth = !this.isCollapsed ? this.width : this.collapsedWidth;
    this.menuItems.forEach(() => this.menuItemIsVisited.push(false));
  }

  toggleMenu() {
    this.menuWidth = this.menuWidth === this.width ? this.collapsedWidth : this.width;
    this.menuWidthChanged.emit(this.menuWidth);
  }

  nextMenuItemIndex() {
    this.menuItemIndex = this.menuItemIndex < this.menuItems.length - 1 ? this.menuItemIndex + 1 : 0;
    this.menuItemSelectionChanged.emit(this.menuItemIndex);
  }

  previousMenuItemIndex() {
    this.menuItemIndex = this.menuItemIndex > 0 ? this.menuItemIndex - 1 : this.menuItems.length - 1;
    this.menuItemSelectionChanged.emit(this.menuItemIndex);
  }

  menuItemSelected(index: number, menuItem: any) {
    this.menuItemIndex = index;
    this.menuItemIsVisited[index] = true;
    this.menuItemSelectionChanged.emit(index);

    let mfdsm = null;
    if (typeof (menuItem.moduleFunctionDynamicSubMenu) !== "undefined") {
      //piggyback the clicked menu-index
      if (menuItem.moduleFunctionDynamicSubMenu != null) {
        menuItem.moduleFunctionDynamicSubMenu.menuIndex = index;
      }
      mfdsm = menuItem.moduleFunctionDynamicSubMenu;
    }
    this.selectedDynamicLayoutChanged.emit(mfdsm);
  }

  isMenuItemSelected(index: number): boolean {
    return this.menuItemIsVisited[index];
  }
}
